export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";